import { useState, useEffect } from 'react'
import { Divider, Result, Progress, Button, Select, Typography, Upload } from 'antd'
import {
  CheckOutlined
  CloseOutlined
  HistoryOutlined
  UploadOutlined
  QuestionOutlined
  LoadingOutlined
} from '@ant-design/icons'
import GeneralTemplate from './general'
import { getRandomUpload, getRandomInit } from '../funnies'
import { handleUpdatingStore } from './helpers'
import { pluginStatuses } from 'Services/ActionsPagesUtils'
import moment from 'moment'

{ Text } = Typography

UploadFileToBranch = GeneralTemplate({
  InputHandler: ({ inputState, setInputState, startPlugin, uploadFileProgress }) ->
    [initializing, setInitializing] = useState(false)
    [branches, setBranches] = useState(undefined)
    [activeBranch, setActiveBranch] = useState(undefined)

    useEffect( ->
      ( ->
        b = await Weaver.Branch.list()
        setBranches(b)
        setActiveBranch(b[0].id())
      )()
      undefined
    , [])

    handleUpload = ({ file, onSuccess }) ->
      if file
        file.uploadTime = moment()
        setInputState((prev = []) ->
          [file, prev...]
        )
        try
          setInitializing(true)
          onSuccess()
          setTimeout(->
            startPlugin({ file })
          , 1000)
        catch
          setInitializing(false)

    getStatus = (status) ->
      if status is pluginStatuses.ERRORED
        'danger'
      else
        status

    getStatusIcon = (status) ->
      if status is pluginStatuses.ERRORED
        <CloseOutlined />
      else if status is pluginStatuses.DONE
        <CheckOutlined />
      else
        <QuestionOutlined />

    if initializing
      <Result
        type='info'
        icon={<LoadingOutlined/>}
        title='Initializing...'
        subTitle={getRandomInit()}
      />
    else
      if uploadFileProgress <= 100
        <Result
          type='info'
          icon={<Progress type="circle" percent={uploadFileProgress} />}
          title='Uploading file...'
          subTitle={getRandomUpload()}
        />
      else
        <>
          <Upload.Dragger
            data-testid="upload-file"
            disabled={initializing or uploadFileProgress?}
            action={undefined}
            customRequest={handleUpload}
            maxCount={1}
          >
            <p className="ant-upload-drag-icon">
              <UploadOutlined />
            </p>
            <p className="ant-upload-text">Click or drag file to this area to upload</p>
          </Upload.Dragger>
          {
            if inputState?.length > 0
              <>
                <Divider plain><HistoryOutlined /> Upload history</Divider>
                <div style={{ overflow: 'auto', maxHeight: '220px', padding: '0px 16px' }}>
                  {
                    inputState?.map((file) ->
                      date = file.uploadTime.format('HH:mm')
                      <div key={file.uid}>
                        <Text type={getStatus(file.status)}>
                          { getStatusIcon(file.status) } { file.name } ({ date })
                        </Text>
                      </div>
                    )
                  }
                </div>
              </>
          }

          <div style={{ marginTop: 20, fontWeight: 400, opacity: 0.6 }}>Branch to use:</div>
          <Select
            disabled={!branches}
            options={branches?.map((b) -> { label: b.name(), value: b.id() })}
            onSelect={(key) -> setActiveBranch(key)}
            value={activeBranch}
            style={{ width: '100%' }}
          />
        </>

  ResponseHandler: ({ response: { log }, restart }) ->
    handleUpdatingStore(log)

    <Button
      shape="round"
      type="primary"
      onClick={restart}
    >
      Upload another file
    </Button>
})

export default UploadFileToBranch
